"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var field_1 = require("../../../../components/pricing/layout/field/field");

var label_1 = require("../../../../components/pricing/text/label/label");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var constants_1 = require("../../../../theming/pricing-system/constants");

var theme_1 = require("../../../../theming/theme");

var staticTextStyle = {
  alignSelf: 'flex-end',
  color: theme_1.GreyScale.lightest
};

var GroupStaticField = function (_super) {
  __extends(GroupStaticField, _super);

  function GroupStaticField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GroupStaticField.prototype.render = function () {
    return react_1.default.createElement(field_1.Field, {
      viewStyle: this.props.viewStyle
    }, react_1.default.createElement(label_1.Label, {
      label: constants_1.GroupStaticFieldContent.label,
      position: this.props.labelPosition,
      textStyle: this.props.labelTextStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: this.props.groupName,
      textStyle: staticTextStyle
    })));
  };

  return GroupStaticField;
}(react_1.default.PureComponent);

exports.GroupStaticField = GroupStaticField;